<!-- UI-7 C4: Project information pop-up (opened from a project card on the Projects page),
     mirroring the Image detail pop-up. Wraps the existing ProjectDetails (full info + actions)
     so nothing is duplicated; the project name lives in the header (excluded from the body). -->
<template>
<b-modal :active="active" has-modal-card scroll="keep" @update:active="v => $emit('update:active', v)">
  <div class="modal-card pdm-card" v-if="project">
    <header class="modal-card-head pdm-head">
      <span class="pdm-title">{{ project.name }}</span>
      <button class="delete" :aria-label="$t('button-close')" @click="$emit('update:active', false)"></button>
    </header>
    <section class="modal-card-body pdm-body">
      <project-details
        :project="project"
        :excluded-properties="['name']"
        editable
        @update="$emit('update', $event)"
        @delete="$emit('delete')"
      />
    </section>
    <footer class="modal-card-foot pdm-foot">
      <button class="button" @click="$emit('update:active', false)">{{ $t('button-close') }}</button>
      <router-link :to="`/project/${project.id}`" class="button is-link">{{ $t('button-open') }}</router-link>
    </footer>
  </div>
</b-modal>
</template>

<script>
import ProjectDetails from './ProjectDetails';

export default {
  name: 'project-detail-modal',
  components: {ProjectDetails},
  props: {
    active: {type: Boolean, default: false},
    project: {type: Object, default: null}
  }
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/colors.scss';

.pdm-card {
  width: 52rem;
  max-width: 95vw;
}
.pdm-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: $surface;
  border-bottom: 1px solid $line-1;
}
.pdm-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: $ink-1;
}
.pdm-body {
  background: $surface;
}
.pdm-foot {
  background: $surface;
  border-top: 1px solid $line-1;
  justify-content: flex-end;
  gap: 0.6rem;
}
</style>
